import React, { useState } from 'react';

const MinimalTemplate = ({ data, subdomain }) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://personal-site-saas-api.l5819033.workers.dev';
    const [contactFormData, setContactFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleContactChange = (e) => {
        setContactFormData({
            ...contactFormData,
            [e.target.name]: e.target.value
        });
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const response = await fetch(`${API_BASE_URL}/api/site/${subdomain}/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactFormData),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            setSubmitStatus('success');
            setContactFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };
    const hero = data.hero || {};
    const experiences = data.experiences || [];
    const education = data.education || [];
    const competencies = data.competencies || [];
    const tools = data.tools || [];
    const languages = data.languages || [];

    return (
        <div className="tpl-minimal">
            <div className="tpl-page">
                <div className="tpl-container">
                    <section className="tpl-hero">
                        <h1>{hero.name || 'Your Name'}</h1>
                        <div className="tpl-sub">{hero.title || 'Your Title'}</div>
                        <div className="tpl-desc">{hero.description || 'Short bio about yourself.'}</div>
                        <div className="tpl-links">
                            {hero.github_url ? (
                                <a className="tpl-btn" href={hero.github_url} target="_blank" rel="noreferrer">GitHub</a>
                            ) : null}
                            {hero.linkedin_url ? (
                                <a className="tpl-btn" href={hero.linkedin_url} target="_blank" rel="noreferrer">LinkedIn</a>
                            ) : null}
                            {hero.cv_url ? (
                                <a className="tpl-btn" href={hero.cv_url} target="_blank" rel="noreferrer">CV</a>
                            ) : null}
                        </div>
                    </section>

                    <section className="tpl-section">
                        <h2>Experience</h2>
                        <div className="tpl-list">
                            {experiences.map((e, i) => (
                                <div key={i} className="tpl-card">
                                    <h3>{e.title || e.position || 'Role'} • <span className="tpl-muted">{e.company || 'Company'}</span></h3>
                                    <div className="tpl-muted">{(e.start_date || '') + (e.end_date ? ` — ${e.end_date}` : ' — Present')}</div>
                                    {e.description ? <div style={{marginTop: 8}}>{e.description}</div> : null}
                                    {Array.isArray(e.achievements) && e.achievements.length > 0 && e.achievements.some(a => a.achievement && a.achievement.trim() !== '') && (
                                        <ul style={{marginTop: 8, paddingLeft: 20}}>
                                            {e.achievements.filter(a => a.achievement && a.achievement.trim() !== '').map((a, idx) => (
                                                <li key={idx} style={{marginTop: 4}}>{a.achievement}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="tpl-section">
                        <h2>Education</h2>
                        <div className="tpl-list">
                            {education.map((ed, i) => (
                                <div key={i} className="tpl-card">
                                    <h3>{ed.degree || 'Degree'} • <span className="tpl-muted">{ed.school || ed.institution || 'School'}</span></h3>
                                    {ed.field ? <div className="tpl-muted">{ed.field}</div> : null}
                                    <div className="tpl-muted">{(ed.start_date || '') + (ed.end_date ? ` — ${ed.end_date}` : ' — Present')}</div>
                                    {ed.description ? <div style={{marginTop: 8}}>{ed.description}</div> : null}
                                    {Array.isArray(ed.achievements) && ed.achievements.length > 0 && ed.achievements.some(a => a.achievement && a.achievement.trim() !== '') && (
                                        <ul style={{marginTop: 8, paddingLeft: 20}}>
                                            {ed.achievements.filter(a => a.achievement && a.achievement.trim() !== '').map((a, idx) => (
                                                <li key={idx} style={{marginTop: 4}}>{a.achievement}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="tpl-section">
                        <h2>Skills</h2>
                        <div className="tpl-list">
                            {competencies.length > 0 && (
                                <div className="tpl-card">
                                    <h3>Competencies</h3>
                                    <div className="tpl-muted">{competencies.map(c => c.name).filter(Boolean).join(' • ')}</div>
                                </div>
                            )}
                            {tools.length > 0 && (
                                <div className="tpl-card">
                                    <h3>Tools</h3>
                                    <div className="tpl-muted">{tools.map(t => t.name).filter(Boolean).join(' • ')}</div>
                                </div>
                            )}
                            {languages.length > 0 && (
                                <div className="tpl-card">
                                    <h3>Languages</h3>
                                    <div className="tpl-muted">{languages.map(l => `${l.name}${l.level ? ` (${l.level})` : ''}`).filter(Boolean).join(' • ')}</div>
                                </div>
                            )}
                        </div>
                    </section>

                    <section className="tpl-section tpl-contact">
                        <h2>Contact</h2>
                        <form onSubmit={handleContactSubmit}>
                            <div style={{display:'grid', gap:12}}>
                                <input 
                                    className="tpl-input" 
                                    placeholder="Name" 
                                    name="name"
                                    value={contactFormData.name}
                                    onChange={handleContactChange}
                                    required
                                />
                                <input 
                                    className="tpl-input" 
                                    type="email"
                                    placeholder="Email" 
                                    name="email"
                                    value={contactFormData.email}
                                    onChange={handleContactChange}
                                    required
                                />
                                <input 
                                    className="tpl-input" 
                                    placeholder="Subject" 
                                    name="subject"
                                    value={contactFormData.subject}
                                    onChange={handleContactChange}
                                    required
                                />
                                <textarea 
                                    className="tpl-textarea" 
                                    rows={4} 
                                    placeholder="Message" 
                                    name="message"
                                    value={contactFormData.message}
                                    onChange={handleContactChange}
                                    required
                                />
                                {submitStatus === 'success' && (
                                    <div style={{ 
                                        padding: '12px', 
                                        backgroundColor: '#d4edda', 
                                        color: '#155724', 
                                        borderRadius: '8px',
                                        border: '1px solid #c3e6cb',
                                        fontSize: '14px'
                                    }}>
                                        Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapılacaktır.
                                    </div>
                                )}
                                {submitStatus === 'error' && (
                                    <div style={{ 
                                        padding: '12px', 
                                        backgroundColor: '#f8d7da', 
                                        color: '#721c24', 
                                        borderRadius: '8px',
                                        border: '1px solid #f5c6cb',
                                        fontSize: '14px'
                                    }}>
                                        Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.
                                    </div>
                                )}
                                <button 
                                    className="tpl-send" 
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default MinimalTemplate;
